import React from "react";

function TermsModal({ isOpen, onClose }) {
  if (!isOpen) return null;
  return (
    <div className="modal-overlay" style={{color: "black",position: 'fixed', top:0, left:0, width:'100vw', height:'100vh', background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000}}>
      <div className="modal-content" style={{ padding:'2rem', borderRadius:'8px', minWidth:'300px', maxWidth:'90vw', maxHeight:'90vh', overflowY:'auto'}}>
        <button onClick={onClose} style={{float:'right', fontSize:'1.2rem', border:'none', background:'none', cursor:'pointer'}}>×</button>
        <h2>Terms of Service</h2>
        <div style={{marginTop:'1rem'}}>
          <p>Welcome to Weekly Pickem! By using our site, you agree to the following terms:</p>
          <ol>
            <li>This application is for entertainment, educational and
                informative purposes only.</li>
            <li>There are no fees or money associated in this application</li>
            <li>Do not attempt to manipulate or cheat the system.</li>
            <li>Respect other users and refrain from abusive language.</li>
            <li>Your data may be used to improve the service.</li>
            <li>We reserve the right to update these terms at any time.</li>
            <li>Contact us at weeklypickem25@gmail.com for questions.</li>
          </ol>
          <p>By continuing to use Weekly Pickem, you acknowledge and accept these terms.</p>
        </div>
      </div>
    </div>
  );
}

export default TermsModal;
